import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {AuthenticationService} from "@services";

export const UserRoleResolver: ResolveFn<Observable<String | null> | String | null> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   auth: AuthenticationService = inject(AuthenticationService),
   router: Router = inject(Router)): Observable<String | null> | String | null => {
    return auth.userRole.value;
  }
